import { TotalCropReportTable, TableContentWithoutEditDateFromat } from '../../Common/Table/tableContent';
import React, { Fragment } from "react";
import tokenService from '../../../Common/tokenDecoder';
import Typography from '@material-ui/core/Typography';
import { Grid, Box } from '@material-ui/core';

export default class ComponentToPrint extends React.Component {
    render() {

        const tagNumberValues = this.props.data;
        const rowNames = this.props.rowNames;
        const searchData = this.props.searchData;
        const totalRow = this.props.totalRow;
        const columeNames = this.props.columeNames;

        return (
            <div>
                <div style={{ width: '1093px', height: '1059px', padding: '20px', marginBottom: "14rem" }}>
                    <br />
                    <h3><center><u>Tag Details</u></center></h3>
                    <br />
                    <div className="row pl-2 pb-4 pt-4">
                        <div className="col"><b>Group : </b> {searchData.group}</div>
                        <div className="col"><b>Company : </b> {searchData.estate}</div>
                        <div className="col"><b>User : </b> {tokenService.getUserNameFromToken()}</div>
                        <div className="col"><b>Date/Time : </b> {new Date().toLocaleString()}</div>
                        <div className="col"><b>Order Number : </b> {tagNumberValues.orderNumber}</div>
                    </div>
                    <div>
                    <br />
                    <br />
                    <br />
                        <Box maxwidth={1050}>
                            <Grid item xs={12}>
                                <Grid spacing={12} >
                                    <Grid item style={{ textAlign: "center" }} >
                                        <Typography style={{ fontWeight: "bold", textAlign: "center" }} variant="h5" component="div" gutterBottom>
                                            Tag Number : {tagNumberValues.tagNo}
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <br />
                                <Grid container spacing={3}>
                                    <Grid item md={2} xs={12} style={{ textAlign: "center" }}>
                                        <Typography style={{ fontWeight: "bold" }} variant="h6" component="div" gutterBottom>
                                            Buyer : {tagNumberValues.buyerName} &nbsp; Order No : {tagNumberValues.orderNumber}
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <br />
                                <Grid container spacing={3}>
                                    <Grid item md={2} xs={12} style={{ textAlign: "center" }}>
                                        <Typography style={{ fontWeight: "bold" }} variant="h6" component="div" gutterBottom>
                                            Supplier : {tagNumberValues.supplierName} &nbsp; Product : {tagNumberValues.product}
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <br />
                                <Grid container spacing={3}>
                                    <Grid item md={2} xs={12} style={{ textAlign: "center" }}>
                                        <Typography style={{ fontWeight: "bold" }} variant="h6" component="div" gutterBottom>
                                            Invoice Date : {tagNumberValues.invoiceDate} &nbsp; Due Date : {tagNumberValues.dueDate}
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <br />
                                <Grid container spacing={3}>
                                    <Grid item md={2} xs={12} style={{ textAlign: "center" }}>
                                        <Typography style={{ fontWeight: "bold" }} variant="h6" component="div" gutterBottom>
                                            Weigh Date : {tagNumberValues.createdDate} &nbsp; Measuring Unit : {tagNumberValues.measuringUnit == 1 ? "Kg" : "Unit"}
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <br />
                                <Grid container spacing={3}>
                                    <Grid item md={2} xs={12} style={{ textAlign: "center" }}>
                                        <Typography style={{ fontWeight: "bold" }} variant="h6" component="div" gutterBottom>
                                            Gross Weight : {tagNumberValues.grossAmount} {tagNumberValues.measuringUnit == 1 ? "Kg" : "Unit"} &nbsp; Net Weight : {tagNumberValues.netAmount} {tagNumberValues.measuringUnit == 1 ? "Kg" : "Unit"}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Box>
                    </div>
                </div>
            </div>
        );
    }
}